<input type="hidden">
<div [ngClass]="dropdownActiveClass" class="text" [ngClass]="{'default':!loadingOptions}">{{placeholder}}</div>
<span class="icon" *ngIf="loadingOptions">
  <div class="ui active inline mini loader" style="float: right;"></div>
</span>
<i class="dropdown icon"></i>
<div class="menu notHide">
  <ng-container *ngIf="!loadingOptions">
    <ng-container *ngFor="let item of items">
      <div *ngIf="item.optgroup" class="header">{{item.optgroup}}</div>
  
      <div
        [attr.data-value]="item.value"
        [ngClass]="item.class"
        [class.disabled]="!isEditable(item)"
        class="item"
      >
        <i *ngIf="item.icon" [ngClass]="item.icon" class="icon"></i>
        <div *ngIf="item.color && !item.image" class="image" [style.backgroundColor]="item.color"></div>
        <img *ngIf="item.image" [src]="item.image" [style.backgroundColor]="item.color">
        <span>{{item.name}}</span>
        <div class="dropdown-option__description">
          <i *ngIf="item.descriptionIcon" [ngClass]="item.descriptionIcon" class="icon"></i>
          <span *ngIf="item.description">{{item.description}}</span>
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>
